import AppRouter from '@shared/navigation/AppRouter';
import React from 'react';

export default () => {
  return <AppRouter />;
};
